import { useCallback } from "react";
import { useFormikContext } from "formik";
import { isEqual, omit } from "lodash";

const useEquipmentQuantity = () => {
  const { values, setFieldValue } = useFormikContext();

  const handleQuantityChange = useCallback(
    (id, index, newQuantity) => {
      if (newQuantity < 0) return;

      if (newQuantity === 0) {
        const equipmentIndex = values.equipments.findIndex(
          (eqp, i) => eqp.id === id && i === index,
        );

        if (equipmentIndex === -1) return;

        const updatedEquipments = [
          ...values.equipments.slice(0, equipmentIndex),
          ...values.equipments.slice(equipmentIndex + 1),
        ];
        setFieldValue("equipments", updatedEquipments);
        return;
      }

      const updatedEquipments = values.equipments.map((eqp, i) => {
        if (eqp.id === id && i === index) {
          return { ...eqp, quantity: newQuantity };
        }
        return eqp;
      });

      setFieldValue("equipments", updatedEquipments);
    },
    [values.equipments, setFieldValue],
  );

  const handleAddEquipment = useCallback(
    (newEquipment) => {
      const similarEquipmentPresent = values.equipments.findIndex((eqp) => {
        const eqp1 = omit(eqp, ["quantity"]);
        const eqp2 = omit(newEquipment, ["quantity"]);
        return isEqual(eqp1, eqp2);
      });

      if (similarEquipmentPresent !== -1) {
        const updatedEquipments = values.equipments.map((eqp, index) => {
          if (index === similarEquipmentPresent) {
            return {
              ...eqp,
              quantity: (eqp.quantity || 1) + (newEquipment.quantity || 1),
            };
          }
          return eqp;
        });

        setFieldValue("equipments", updatedEquipments);
      } else {
        setFieldValue("equipments", [
          ...values.equipments,
          { ...newEquipment, quantity: newEquipment.quantity || 1 },
        ]);
      }
    },
    [values.equipments, setFieldValue],
  );

  return { handleQuantityChange, handleAddEquipment };
};

export default useEquipmentQuantity;
